// extracted by mini-css-extract-plugin
export default {"BurgerMenu":"BurgerMenu_BurgerMenu__3FFp+","header":"BurgerMenu_header__zd+UH","itemsCon":"BurgerMenu_itemsCon__ac99u","active":"BurgerMenu_active__H6kWZ"};